/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Total statistic
 * @export
 * @interface TotalStatistic
 */
export interface TotalStatistic {
    /**
     * @type {number}
     * @memberof TotalStatistic
     */
    devices_installed?: number;
    /**
     * @type {number}
     * @memberof TotalStatistic
     */
    devices_damaged_installed?: number;
    /**
     * @type {number}
     * @memberof TotalStatistic
     */
    devices_replacements?: number;
    /**
     * @type {number}
     * @memberof TotalStatistic
     */
    devices_active?: number;
    /**
     * @type {number}
     * @memberof TotalStatistic
     */
    positions_empty?: number;
}
